module.exports = '<svg width="15" height="32" viewBox="0 0 15 32"><path d="M1.392 20.002h6v11.124c0 1.106.332 1.168.742.142l6.516-17.412c.41-1.022-.152-1.854-1.258-1.854h-6V.874c0-1.106-.332-1.168-.742-.142L.134 18.142c-.41 1.028.154 1.86 1.258 1.86z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/battery-charging-3.js
// module id = 1000
// module chunks = 14